module.exports = __webpack_public_path__ + "static/media/iris_data_set.fe4dd869.png";